function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "D2C79E1C-B4A1-46FE-8B3D-527C0190B995");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Landing_Sign-in_find\uD074\uB9AD-Copy-4",
  transform: "translate(-885.000000, -389.000000)"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(885.000000, 389.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#7552F6",
  cx: 11.5,
  cy: 11.5,
  r: 11.5
}), React.createElement("polygon", {
  id: "Checkmark",
  fill: "#FFFFFF",
  points: "7.26923077 10.8076923 6 12.0769231 9.38461538 15.4615385 17 8.26923077 15.7307692 7 9.38461538 12.9230769"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/input-check-valid.91cb3638.svg";
export { SvgComponent as ReactComponent };